import { ItemPageBreadcrumbsPluginModel } from '@marketplace-web/item-page/item-page-data'

export const getItemPageBreadcrumbsPluginModel = (
  data: ItemPageBreadcrumbsPluginModel,
): ItemPageBreadcrumbsPluginModel => ({
  breadcrumbs: data.breadcrumbs.map(breadcrumb => ({
    title: breadcrumb.title,
    url: breadcrumb.url,
  })),
})
